export default "__VITE_ASSET__BVDXu8zX__"